<template>
 <div class="guide-pages">
 	<div class="guide-pages__lazy">
 	  <el-image v-for="url in imageList" :key="url" :src="url" lazy>
	   <div slot="error" class="image-slot">
		  <i class="el-icon-picture-outline"></i>
		</div>
	  </el-image>
 	</div>
 </div>
</template>

<script>
export default {
  name: "courseGuide",
  data() {
    return {
      imageList: [
		'http://img-dbzd.doubaozhidao.com/20220815/yiYX7pkJJjMRnTd7WcA3i4fa5xCNN28a1660554235280.jpg?x-oss-process=image/quality,q_80/format,jpg',
		'http://img-dbzd.doubaozhidao.com/20220815/HFhHb2BjZYTyRQP43ZYtjB8DYeT27s5m1660554235287.jpg?x-oss-process=image/quality,q_80/format,jpg',
		'http://img-dbzd.doubaozhidao.com/20220815/JZF2N7K26hEJSN7CMpnaHEpspQp2FYBR1660554235284.jpg?x-oss-process=image/quality,q_80/format,jpg',
		'http://img-dbzd.doubaozhidao.com/20220815/QKdDmrxt5MJMQ68Kwpny8QCTpXY68rX81660554235281.jpg?x-oss-process=image/quality,q_80/format,jpg',
		'http://img-dbzd.doubaozhidao.com/20220815/Mtk8prXSR5ZfbjCxKJtFHAQTHt4ZtmiD1660554235285.jpg?x-oss-process=image/quality,q_80/format,jpg',
		'http://img-dbzd.doubaozhidao.com/20220815/KWhjc43rws2Ea4pJSkRQ8b6Pc8m8MxyM1660554235284.jpg?x-oss-process=image/quality,q_80/format,jpg',
		'http://img-dbzd.doubaozhidao.com/20220815/FGT7ebh4GPm2BEkXDd7TzxFpzGz8N5eZ1660554235287.jpg?x-oss-process=image/quality,q_80/format,jpg',
		'http://img-dbzd.doubaozhidao.com/20220815/HBYFSkzdJyX87TyiGmNYfzxFmjRTatnc1660554235286.jpg?x-oss-process=image/quality,q_80/format,jpg',
		'http://img-dbzd.doubaozhidao.com/20220815/EfzkBQsaR6rfPi7n5n2Tnt4HfQX4fbBc1660554235283.jpg?x-oss-process=image/quality,q_80/format,jpg',
		'http://img-dbzd.doubaozhidao.com/20220815/RcshB82Qn3cYZ5hGmPbQZbtdkaynF6Et1660554235286.jpg?x-oss-process=image/quality,q_80/format,jpg'
       ]
    }
  }
}
</script>
<style lang="less" scoped>
	.guide-pages__lazy{
		width: 100%;
		margin: 0 auto;
		display: block;
	}
	.guide-pages__lazy .el-image{
		width: 750px;
		margin: 0 auto;
		display: block;
	}
	
	
	.guide-pages__lazy img{
		width: 100%;
		margin: 0 auto;
		display: block;
	}
</style>
